// Entry point for the build script in your package.json
import "./controllers"

const fadeFlash = () => {
  setTimeout(() => {
    let flashMessage = document.getElementById('flash-message-container');
    if (!flashMessage) return;

    let fadeEffect = setInterval(() => {
        if (!flashMessage.style.opacity) {
            flashMessage.style.opacity = 1;
        }
        if (flashMessage.style.opacity > 0) {
            flashMessage.style.opacity -= 0.1;
        } else {
            clearInterval(fadeEffect);
            flashMessage.style.display = 'none';
      }
    }, 50);
  }, 3000);
}

document.addEventListener('DOMContentLoaded', fadeFlash);
document.addEventListener('turbo:load', fadeFlash);
